module.exports = __webpack_public_path__ + "img/appstore.0f5bdb85.svg";